import { useRef } from "react";
import classNames from "classnames";

import useOnScreen from "../../hooks/useOnScreen";

/** Fades and lifts children in the first time they scroll into view. */
const Reveal = ({ as: Tag = "div", className, delay = 0, children, ...rest }) => {
  const ref = useRef(null);
  const visible = useOnScreen({ ref, rootMargin: "-60px", onlyOnce: true });

  return (
    <Tag
      ref={ref}
      className={classNames("piggy-reveal", className, {
        "piggy-reveal--in": visible,
      })}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
